module.exports = __webpack_public_path__ + "img/Galactapedia_Argo_Astronautics.42bf65ac.png";